import ModuleParticipation from '@/components/participation/ModuleParticipation.vue';
import API from '@/service/hub-api';
import Store from '@/store';
import Logger from '@/utils/logger';

const participationRouter = {
  routes: [
    {
      path: '/module-participation',
      name: 'moduleParticipation',
      component: ModuleParticipation,
    },
  ],
};

participationRouter.guard = async (to, from) => {
  const runningModuleData = await API.get(`/running-modules/fac/${Store.getters.loginUser.id}`);
  const runningModule = runningModuleData.records[0] || null;

  // No participation form needs to be completed
  if (!runningModule) {
    // Participation page can not be accessed
    if (to.name === 'moduleParticipation') {
      Logger.debug(`Back to: ${from.path}`);
      throw new Error('$Reject');
    }

    // Go through to the requested page
    return;
  }

  // There is a participation form to complete

  // Some participation forms need the permission to create new clients
  if (to.name === 'newClient') {
    // Set participation page as the parent of client form page
    Store.commit('setHUBSettingItems', {
      levelUp: { name: 'moduleParticipation' },
    });

    // Go through to client creation form
    return;
  }

  // Must complete participation first
  if (to.name !== 'moduleParticipation') {
    Logger.debug('Forward to: /module-participation');
    throw new Error('/module-participation');
  }

  // Set running module data for participation page
  Store.commit('setHUBSettingItems', { runningModule });

  // Go to participation page
  Logger.debug('Access: /module-participation');
  throw new Error();
};

export default participationRouter;
